import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import EcoImg from 'eco-design/base/eco-img';

import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { useScrollAnimation, cn } from 'elem/compPage/battery-backup-for-home/scroll-animation-v2';

export default function Voices() {
    const { t } = useLang('powerbackup');
    const { locale } = getLocal();

    const lists = [
        {
            title: t('secK_list4_title'),
            desc: t('secK_list4_desc'),
        },
        {
            title: t('secK_list1_title'),
            desc: t('secK_list1_desc'),
        },
        {
            title: t('secK_list2_title'),
            desc: t('secK_list2_desc'),
        },
        {
            title: t('secK_list3_title'),
            desc: t('secK_list3_desc'),
        },
    ];

    const { ref, isVisible } = useScrollAnimation({
        threshold: 0.1,
    });

    return (
        <div ref={ref} className={`${styles.Voices} GtmModuleData-section`}>
            <div className="pb-layout">
                <div className={cn(isVisible, 'power-backup-title fade-up')}>{t('secK_title')}</div>
                <Swiper
                    style={{ '--animate-delay': '0.15s' } as React.CSSProperties}
                    className={cn(isVisible, 'swiper-box fade-up')}
                    effect="fade"
                    modules={[Scrollbar, Navigation]}
                    spaceBetween={20}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 'auto',
                        snapOnRelease: true,
                    }}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                >
                    {lists?.map((card, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            <EcoImg
                                pc={'https://websiteoss.ecoflow.com/figma-uploads/1767684512559-ky13fk-compressed-pc.jpg'}
                                pad="https://websiteoss.ecoflow.com/figma-uploads/1767684760728-c62f8t-compressed-laptop.jpg"
                                h5="https://websiteoss.ecoflow.com/figma-uploads/1767684787774-bl8i1p-compressed-mob.jpg"
                            />
                            <div className="bottom-wrapper">
                                <div className="bottom-desc">{card.desc}</div>

                                <div className="bottom-title">{card.title}</div>
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev" />
                    <div className="swiper-button-next" />
                </Swiper>
            </div>
        </div>
    );
}
